export default __webpack_public_path__ + "images/V8.4d76b9c.png";